import { connect } from 'react-redux';

import {
    DispatchPropsType,
    MapStateType,
    OwnProps,
} from '../../organisms/receiveMessage/urlShortenerForm';
import URLShortenerForm from '../../organisms/receiveMessage/urlShortenerForm';
import { getParams } from '../../../../../store/sidebar';
import { requestObject } from '../../../../../store/Object';
import { Instances } from '../../../../../constants';

const mapStateToProps = (state: any, props: any) => ({
    isEdit: getParams(state),
});

const mapDispatchToProps = {
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.urlShortenerCreate, undefined, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onEdit: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.urlShortenerUpdate, { _method: 'PUT' }, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onFileUpload: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.textlyFileUpload, undefined, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
};

export default connect<MapStateType, DispatchPropsType, OwnProps, any>(
    mapStateToProps,
    mapDispatchToProps
)(URLShortenerForm);
